<template>
      <v-dialog v-model="dialog" persistent max-width="800px">
        <v-form v-model="valid" ref="form" lazy-validation>
      <v-card>
        <v-toolbar dark color="primary elevation-1">
          <v-btn icon @click.native="close" dark>
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Add client</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click.native="save">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm4 md4>
                <v-text-field v-model="form.firstname" label="Firstname" required :rules="itemRules"></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field v-model="form.lastname" label="Lastname" required :rules="itemRules"></v-text-field>
              </v-flex>

              <v-flex xs10>
                <g-input
                  :required="true"
                  ref="address"
                  id="address"
                  @change="setAddress"
                  @placechanged="setPlace"
                  :label="'Address'"
                  :clearable="true"
                  :delete="true"
                  :rules="itemRules"
                  :error="adress_notValid"
                ></g-input>
                <span v-if="adress_notValid" class="input-group__details error--text">Address is uncomplete, select a completed address.</span>
              </v-flex>
              <v-flex xs2>
                <v-text-field v-model="form.postbox" label="Postbox"></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field v-model="form.birthday" label="birthday"></v-text-field>
              </v-flex>

              <v-flex xs12 sm4 md4>
                <v-text-field v-model="form.mobile" label="mobile" required></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field v-model="form.tel" label="tel" required></v-text-field>
              </v-flex>

              <v-flex xs12 sm4 md4>
                <v-text-field v-model="form.email" label="Email"></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md3>
                <v-text-field v-model="form.client_from" label="Client from"></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md3>
                <v-text-field v-model="form.ssn" label="Register nr"></v-text-field>
              </v-flex>
              <v-flex xs2>
                <v-text-field v-model="form.mcode" label="M-code"></v-text-field>
              </v-flex>
              <v-flex xs12 sm3>
                <v-text-field
                  label="Price"
                  v-model="form.basePrice"
                  prepend-icon="euro_symbol"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm3 >
              <v-checkbox class="mt-3"
                color="primary"
                label="Factuur client?"
                v-model="form.factuur"
              ></v-checkbox>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  label="Info"
                  v-model="form.info"
                  prepend-icon="info"
                  auto-grow
                  outlined
                  rows="3"
                  row-height="25"
                ></v-textarea>
              </v-flex>
              <v-flex xs12>

              <v-checkbox class="mt-3" @change="toggleInvoice"
              color="primary"
                label="Other invoice address?"
                v-model="invoiceAddress"
              ></v-checkbox>
              </v-flex>
              <v-flex xs12 v-if="invoiceAddress">
                <v-layout wrap class="invoiceAddress">
                  <v-flex xs12>
                    <div class="invoice-label">Use this for invoices:</div>
                    <v-text-field v-model="form.invoiceName" label="Name"></v-text-field>
                  </v-flex>
                  <v-flex xs10>
                    <g-input
                      id="invoiceAddress"
                      ref="invoice"
                      @change="setInvoiceAddress"
                      @placechanged="setInvoicePlace"
                      :label="'Address'"
                      :clearable="true"
                      :delete="true"
                      :rules="itemRules"
                      :error="fadress_notValid"
                    ></g-input>
                    <span v-if="fadress_notValid" class="input-group__details error--text">Address is uncomplete, select a completed address.</span>
                  </v-flex>
                  <v-flex xs2>
                    <v-text-field v-model="form.postbox2" label="Postbox"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12>
                <v-textarea
                  label="History"
                  v-model="form.comment"
                  prepend-icon="chat"
                  multi-line
                ></v-textarea>
              </v-flex>

            </v-layout>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
      </v-card>
      </v-form>
    </v-dialog>
</template>

<script>
  import ClientFormMixin from '@/mixins/client-form';
  export default {
    mixins: [ClientFormMixin],
    data () {
      return {
      }
    }
  }
</script>

<style lang="scss">
.invoiceAddress {
  border: solid 1px #eee;
  padding: 0 20px 20px;
  .invoice-label {
    padding-top: 10px;
    color: #ccc;
  }
}
</style>
